import { createSlice } from '@reduxjs/toolkit';
import { OrdersUpdateStateType } from 'src/types/ordersUpdate';

const initialState: OrdersUpdateStateType = {
    loading: false,
    loadingMultiple: false,
};
export const ordersUpdateSlice = createSlice({
    name: 'ordersUpdate',
    initialState,
    reducers: {
        patchOrderFetch: (state, action) => {
            state.loading = true;
        },
        patchOrderFetchSuccess: (state) => {
            state.loading = false;
        },
        patchOrderFetchFailure: (state, action) => {
            state.loading = false;
        },
        patchMultipleOrdersFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        patchMultipleOrdersFetchSuccess: (state) => {
            state.loadingMultiple = false;
        },
        patchMultipleOrdersFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        },
        addOrderProductsFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        addOrderProductsFetchSuccess: (state, action) => {
            state.loadingMultiple = false;
        },
        addOrderProductsFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        },
        removeOrderProductsFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        removeOrderProductsFetchSuccess: (state, action) => {
            state.loadingMultiple = false;
        },
        removeOrderProductsFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        },
        ordersChangeStatusFetch: (state, action) => {
            state.loading = true;
        },
        ordersChangeStatusFetchSuccess: (state) => {
            state.loading = false;
        },
        ordersChangeStatusFetchFailure: (state, action) => {
            state.loading = false;
        },
        reorderOrderShippingFetch: (state, action) => {
            state.loading = true;
        },
        reorderOrderShippingFetchSuccess: (state) => {
            state.loading = false;
        },
        reorderOrderShippingFetchFailure: (state, action) => {
            state.loading = false;
        },
        reorderMultipleOrdersShippingFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        reorderMultipleOrdersShippingFetchSuccess: (state) => {
            state.loadingMultiple = false;
        },
        reorderMultipleOrdersShippingFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        },
        synchronizeOrdersDCIXFetch: (state, action) => {
            state.loadingMultiple = true;
        },
        synchronizeOrdersDCIXFetchSuccess: (state, action) => {
            state.loadingMultiple = false;
        },
        synchronizeOrdersDCIXFetchFailure: (state, action) => {
            state.loadingMultiple = false;
        },
    },
});

export const {
    patchOrderFetch,
    patchOrderFetchSuccess,
    patchOrderFetchFailure,
    patchMultipleOrdersFetch,
    patchMultipleOrdersFetchSuccess,
    patchMultipleOrdersFetchFailure,
    ordersChangeStatusFetch,
    ordersChangeStatusFetchSuccess,
    ordersChangeStatusFetchFailure,
    reorderOrderShippingFetch,
    reorderOrderShippingFetchSuccess,
    reorderOrderShippingFetchFailure,
    reorderMultipleOrdersShippingFetch,
    reorderMultipleOrdersShippingFetchSuccess,
    reorderMultipleOrdersShippingFetchFailure,
    synchronizeOrdersDCIXFetch,
    synchronizeOrdersDCIXFetchSuccess,
    synchronizeOrdersDCIXFetchFailure,
    addOrderProductsFetch,
    addOrderProductsFetchSuccess,
    addOrderProductsFetchFailure,
    removeOrderProductsFetch,
    removeOrderProductsFetchSuccess,
    removeOrderProductsFetchFailure,
} = ordersUpdateSlice.actions;

export default ordersUpdateSlice.reducer;
